import $ from 'jquery';
import { Utility } from 'App/track/analytics/util';
import { Universal } from 'App/track/analytics/universal';
import { publish, unpublish, subscribe } from 'Util/pubsub';

var $sharePopup;
var $shareEmail;

var selectors = {
	sharePopup: '.js-social-popup',
	shareEmail: '.js-social-email',
	dataValue: 'trackValue'
};

var Share = {
	init: function () {
		// console.log('Track Share Init');

		Share = this;

		Share._initElements();
		Share._initSubscriptions();
		Share._initEvents();
	},

	_initElements: function () {
		$sharePopup = $(selectors.sharePopup);
		$shareEmail = $(selectors.shareEmail);
	},

	_initSubscriptions: function () {

	},

	_initEvents: function () {
		$sharePopup.on('click', Share._processShareClick);
		$shareEmail.on('click', Share._processShareClick);
	},

	_processShareClick: function () {
		// console.log('Track Share Click');

		var $link = $(this);
		var value = Share._setValue($link);
		var data = {
			eventCategory: 'Share',
			eventAction: $.trim($link.text()),
			eventLabel: '',
			eventValue: value
		};

		Utility.publishEvent(data);
	},

	_setValue: function ($link) {
		var value;

		if (typeof $link.data(selectors.dataValue) != 'undefined') {
			value = $link.data(selectors.dataValue) + 1;
		} else {
			value = 1;
		}
		$link.data(selectors.dataValue, value);

		return value;
	}
};

export { Share };